import { render, staticRenderFns } from "./NothModal.vue?vue&type=template&id=fc38a59a&scoped=true"
import script from "./NothModal.vue?vue&type=script&lang=js"
export * from "./NothModal.vue?vue&type=script&lang=js"
import style0 from "./NothModal.vue?vue&type=style&index=0&id=fc38a59a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc38a59a",
  null
  
)

export default component.exports